/**
 * Formats a date to dd.mm.yyyy format
 * @param date - Date object or date string
 * @returns Formatted date string or "-" if date is null/undefined
 */
export const formatDate = (date?: Date | null): string => {
    if (!date) return "-";
    const dateObj = date instanceof Date ? date : new Date(date);
    const day = String(dateObj.getDate()).padStart(2, "0");
    const month = String(dateObj.getMonth() + 1).padStart(2, "0");
    const year = dateObj.getFullYear();
    return `${day}.${month}.${year}`;
};

/**
 * Formats a number as Norwegian currency (NOK)
 * @param value - Numeric value to format
 * @returns Formatted currency string
 */
export const formatAmount = (value?: number | null): string => {
    const asNumber = Number(value || 0);
    return asNumber.toLocaleString("no-NO", {
        maximumFractionDigits: 2,
        style: "currency",
        currency: "NOK",
    });
};

export const formatWeight = (value?: number | null, fractionDigits: number = 2, showOnZero: boolean = true) => {
    if (value === undefined || value === null) {
        return "-";
    }

    const asNumber = Number(value || 0);

    if (!showOnZero && asNumber === 0) {
        return "-";
    }

    return `${asNumber.toLocaleString("no-NO", {
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits,
    })} kg`;
};

export const formatCurrency = (value?: number | null) => {
    const asNumber = Number(value || 0);
    return asNumber.toLocaleString("no-NO", {
        maximumFractionDigits: 2,
        style: "currency",
        currency: "NOK",
    });
};

export const formatNumber = (value?: number | null, fractionDigits = 0) => {
    const asNumber = Number(value || 0);
    return asNumber.toLocaleString("no-NO", {
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits,
    });
};



export const getValue = <T,>(item: any, camelKey: string, pascalKey: string): T | undefined => {
	return (item[camelKey] ?? item[pascalKey]) as T | undefined;
};


